var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { accessPointsApi } from "../../../api/enpoints/access-points-api";
// Get single access point thunk
export const getAccessPoint = createAsyncThunk("accessPoints/getAccessPoint", (accessPointUid_1, _a) => __awaiter(void 0, [accessPointUid_1, _a], void 0, function* (accessPointUid, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield accessPointsApi.getAccessPoint(accessPointUid);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch access point");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch access point");
    }
}));
// Get all access points thunk
export const getAllAccessPoints = createAsyncThunk("accessPoints/getAllAccessPoints", (query_1, _a) => __awaiter(void 0, [query_1, _a], void 0, function* (query, { rejectWithValue, signal }) {
    var _b, _c;
    try {
        const response = yield accessPointsApi.getAllAccessPoints(query, signal);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch access points");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch access points");
    }
}));
// Get access point general settings thunk
export const getAccessPointGeneral = createAsyncThunk("accessPoints/getAccessPointGeneral", (accessPointUid_1, _a) => __awaiter(void 0, [accessPointUid_1, _a], void 0, function* (accessPointUid, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield accessPointsApi.getAccessPointGeneral(accessPointUid);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message ||
                "Failed to fetch access point general settings");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch access point general settings");
    }
}), {
    condition: (_, { getState }) => {
        const { accessPoint } = getState();
        // Prevent duplicate calls while already loading
        if (accessPoint.singleLoading)
            return false;
    },
});
// Update access point general settings thunk
export const updateAccessPointGeneral = createAsyncThunk("accessPoints/updateAccessPointGeneral", (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ accessPointUid, data, }, { rejectWithValue }) {
    var _c, _d;
    try {
        const response = yield accessPointsApi.updateAccessPointGeneral(accessPointUid, data);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message ||
                "Failed to update access point general settings");
        }
    }
    catch (error) {
        return rejectWithValue(((_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to update access point general settings");
    }
}));
// Get access point configuration settings thunk
export const getAccessPointConfiguration = createAsyncThunk("accessPoints/getAccessPointConfiguration", (accessPointUid_1, _a) => __awaiter(void 0, [accessPointUid_1, _a], void 0, function* (accessPointUid, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield accessPointsApi.getAccessPointConfiguration(accessPointUid);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch access point configuration");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch access point configuration");
    }
}));
// Update access point configuration settings thunk
export const updateAccessPointConfiguration = createAsyncThunk("accessPoints/updateAccessPointConfiguration", (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ accessPointUid, data, }, { rejectWithValue }) {
    var _c, _d;
    try {
        const response = yield accessPointsApi.updateAccessPointConfiguration(accessPointUid, data);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message ||
                "Failed to update access point configuration");
        }
    }
    catch (error) {
        return rejectWithValue(((_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to update access point configuration");
    }
}));
// Legacy update access point thunk
export const updateAccessPoint = createAsyncThunk("accessPoints/updateAccessPoint", (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ accessPointUid, data, }, { rejectWithValue }) {
    var _c, _d;
    try {
        const response = yield accessPointsApi.updateAccessPoint(accessPointUid, data);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to update access point");
        }
    }
    catch (error) {
        return rejectWithValue(((_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to update access point");
    }
}));
// Create access point config (download file) thunk
export const createAccessPointConfig = createAsyncThunk("accessPoints/createAccessPointConfig", (data_1, _a) => __awaiter(void 0, [data_1, _a], void 0, function* (data, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield accessPointsApi.createAccessPointConfig(data);
        // Create a download link for the blob
        const blob = new Blob([response.data], {
            type: "application/octet-stream",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `apconfig_${data.accessPointUID}.log`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return { success: true, message: "Config file downloaded successfully" };
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to create access point config");
    }
}));
// Get access points dropdown thunk
export const getAccessPointsDropdown = createAsyncThunk("accessPoints/getAccessPointsDropdown", (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield accessPointsApi.getAccessPointsDropdown();
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch access points dropdown");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch access points dropdown");
    }
}));
// Get access points statistics thunk
export const getAccessPointsStatistics = createAsyncThunk("accessPoints/getAccessPointsStatistics", (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield accessPointsApi.getStatistics();
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch access points statistics");
        }
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch access points statistics");
    }
}));
// Soft delete access point thunk
export const deleteAccessPoint = createAsyncThunk("accessPoints/deleteAccessPoint", (accessPointUid_1, _a) => __awaiter(void 0, [accessPointUid_1, _a], void 0, function* (accessPointUid, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield accessPointsApi.deleteAccessPoint(accessPointUid);
        if (response.data.isSuccess) {
            return accessPointUid;
        }
        return rejectWithValue(response.data.message || "Failed to delete access point");
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to delete access point");
    }
}));
